import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";

const CustomMissionVision = () => {
  const principles = [
    {
      number: "01",
      title: "MISIÓN",
      description:
        "Tratar a todos los pacientes como familia bajo la mejor calidad y tecnología del mercado.",
      background: "#F3D7FA",
      numberColor: "#E9C1F3",
      colorTitulo: "#782A9F",
    },
    {
      number: "02",
      title: "VISIÓN",
      description: "Dejar un legado de bienestar y salud para la gente.",
      background: "#DCEAFB",
      numberColor: "#C6DDF7",
      colorTitulo: "#162E84",
    },
  ];

  return (
    <Box sx={design.Container}>
      <Box sx={design.Header}>
        <CustomText
          color="#782A9F"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          sx={design.Label}
        >
          LO QUE NOS MUEVE
        </CustomText>
        <CustomText
          color="#171717"
          fontWeight={700}
          fontFamily="Nunito"
          textAlign="center"
          sx={design.Title}
        >
          Los principios que guían cada decisión
        </CustomText>
        <CustomText
          color="#333"
          fontWeight={400}
          fontFamily="Nunito"
          textAlign="center"
          sx={design.Description}
        >
          En el corazón de Medam está nuestro compromiso con el cuidado de la
          salud, guiado por valores familiares que destacan
          <br />
          la cercanía y la empatía.
        </CustomText>
      </Box>
      <Grid container sx={design.CardsContainer}>
        {principles.map((item) => (
          <Grid
            key={item.number}
            size={{ xs: 11, md: 3, xl: 3.5, lg: 3 }}
            sx={design.Card(item.background)}
          >
            <CustomText
              color={item.numberColor}
              fontWeight={700}
              fontFamily="Nunito"
              sx={design.Number}
            >
              {item.number}
            </CustomText>

            <CustomText
              color={item.colorTitulo}
              fontWeight={700}
              fontFamily="Nunito"
              textAlign="left"
              sx={design.CardTitle}
            >
              {item.title}
            </CustomText>

            <CustomText
              color="#333"
              fontWeight={400}
              fontFamily="Nunito"
              textAlign="left"
              sx={design.CardDescription}
            >
              {item.description}
            </CustomText>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CustomMissionVision;

const design = {
  Container: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    minHeight: { xs: "auto", md: "380px" },
    py: { xs: 6, md: 7 },
    "&::before": {
      content: '""',
      position: "absolute",
      width: { xs: "250px", md: "600px" },
      height: { xs: "160px", md: "300px" },
      top: "-120px",
      left: "-130px",
      background:
        "radial-gradient(circle, rgba(94,150,210,0.40) 0%, rgba(94,150,210,0.15) 60%, transparent 70%)",
      filter: "blur(20px)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: { xs: "260px", md: "500px" },
      height: { xs: "180px", md: "350px" },
      bottom: "-140px",
      right: "-100px",
      background:
        "radial-gradient(circle, rgba(79,174,91,0.55) 0%, rgba(79,174,91,0.18) 45%, transparent 75%)",
      filter: "blur(25px)",
      pointerEvents: "none",
    },
  },

  Header: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
  },

  Label: {
    fontSize: { xs: 15, sm: 14, md: 14 },
    letterSpacing: "2px",
    mb: 0.5,
  },

  Title: {
    fontSize: { xs: 25, sm: 24, md: 30 },
    lineHeight: 1.2,
  },

  Description: {
    fontSize: { xs: 17, sm: 17, md: 17 },
    lineHeight: 1.35,
    mx: "auto",
    mt: 1.5,
    px: 2,
  },
  CardsContainer: {
    position: "relative",
    zIndex: 1,
    justifyContent: "center",
    alignItems: "center",
    gap: { xs: 2, md: 5 },
    mt: { xs: 3, md: 5 },
  },
  Card: (bgColor) => ({
    position: "relative",
    overflow: "hidden",
    backgroundColor: bgColor,
    height: { xs: "auto", md: "180px" },
    borderRadius: "20px",
    px: { xs: 2, md: 1.8 },
    py: { xs: 2, md: 1.6 },
  }),
  Number: {
    position: "absolute",
    top: "2px",
    right: "20px",
    fontSize: { xs: 62, md: 60 },
    lineHeight: 1,
  },
  CardTitle: {
    fontSize: { xs: 20, md: 20 },
    mb: 1.2,
    mt: 5,
  },
  CardDescription: {
    fontSize: { xs: 18, md: 18 },
    lineHeight: 1.45,
    maxWidth: "90%",
  },
};
